import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const ForbiddenPage: React.FC = () => (
  <div
    data-testid="forbidden-page"
    className="flex flex-col items-center justify-center text-center"
    style={{ minHeight: '100vh', background: '#F8FAFC' }}
  >
    <div className="flex flex-col items-center max-w-[560px] px-8">
      {/* 403 大数字 */}
      <div
        className="font-bold leading-none mb-6"
        style={{ fontSize: 96, color: '#0a7a72', letterSpacing: '-2px' }}
      >
        403
      </div>

      <h1
        className="font-bold mb-4 leading-snug"
        style={{ fontSize: 24, color: '#0F172A' }}
        data-testid="forbidden-title"
      >
        このページにはアクセスできません
      </h1>

      <p
        className="leading-relaxed mb-8"
        style={{ fontSize: 14, color: '#64748B', maxWidth: 400 }}
      >
        アクセス権限がないか、URLが正しくない可能性があります。お困りの場合はサポートまでお問い合わせください。
      </p>

      <Link to="/">
        <Button data-testid="forbidden-back-button">ホームに戻る</Button>
      </Link>

      <p className="mt-5 text-xs" style={{ color: '#94A3B8' }}>
        エラーコード: #ENG403
      </p>
    </div>
  </div>
);
